import React, { Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import s from './styles/TabsProfile.module.scss'
import useTabsProfile from './hooks/useTabsProfile'
import DigitalProfile from './tabs/DigitalProfile/DigitalProfile'
import CareersTab from './tabs/Careers/CareersTab'
import StudentApplicationsTab from './tabs/Applications/StudentApplicationsTab'
import StudentDocVaultTab from './tabs/DocVault/StudentDocVaultTab'
import StudentRecommendationsTab from './tabs/Recommendations/StudentRecommendationsTab'
import StudentNotesTab from './tabs/Notes/StudentNotesTab'

const StudentWishlistTab = React.lazy(
	() => import('./tabs/WishList/StudentWishlistTab'),
)

const TabsProfile = ({
	profileData = null,
	studentId = null,
	studentName = 'Student',
	careerInterests = [],
	isLoadingProfile = false,
}) => {
	const location = useLocation()
	const { tabs, activeTabId, setActiveTabId } = useTabsProfile(
		location.state?.openTab,
	)
	const displayName = studentName || profileData?.name || 'Student'

	return (
		<div className={s.wrap}>
			<div className={s.tabs}>
				<div className={s.tabs__inner}>
					{tabs.map(tab => (
						<button
							key={tab.id}
							type="button"
							className={`${s.tabs__item} ${
								tab.id === activeTabId ? s.active : ''
							}`}
							onClick={() => {
								setActiveTabId(tab.id)
							}}
						>
							<span className={s.tabs__label}>{tab.label}</span>
						</button>
					))}
				</div>
			</div>
			<div className={s.content}>
				<div
					className={[s.tab, activeTabId === 'digital_profile' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<DigitalProfile
						data={profileData}
						studentId={studentId}
						isLoading={isLoadingProfile}
						careerInterests={careerInterests}
						onOpenDocuments={() => setActiveTabId('doc_vault')}
					/>
				</div>
				<div
					className={[s.tab, activeTabId === 'careers' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<CareersTab
						studentId={studentId}
						isActive={activeTabId === 'careers'}
					/>
				</div>
				<div
					className={[s.tab, activeTabId === 'applications' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<StudentApplicationsTab
						studentId={studentId}
						isActive={activeTabId === 'applications'}
					/>
				</div>
				<div
					className={[s.tab, activeTabId === 'doc_vault' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<StudentDocVaultTab
						studentId={studentId}
						studentName={displayName}
						isActive={activeTabId === 'doc_vault'}
					/>
				</div>
				<div
					className={[s.tab, activeTabId === 'recommendations' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<StudentRecommendationsTab
						studentId={studentId}
						studentName={displayName}
						isActive={activeTabId === 'recommendations'}
					/>
				</div>
				<div
					className={[s.tab, activeTabId === 'wishlist' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<Suspense fallback={null}>
						<StudentWishlistTab
							studentId={studentId}
							studentName={displayName}
							isActive={activeTabId === 'wishlist'}
						/>
					</Suspense>
				</div>
				<div
					className={[s.tab, activeTabId === 'notes' && s.active]
						.filter(Boolean)
						.join(' ')}
				>
					<StudentNotesTab
						studentId={studentId}
						studentName={displayName}
						isActive={activeTabId === 'notes'}
					/>
				</div>
			</div>
		</div>
	)
}

export default TabsProfile
